import * as angular from 'angular';
import { combineLatest, Observable } from 'rxjs';

import { routerSelector } from '~/reducers/selectors';
import { AppStore } from '~/types/main.types';

import { ReportViewDataService } from '../services';
import { ReportViewerFacade } from '@mode/report-viewer/domain';
import { map } from 'rxjs/operators';

class ReportDashboard implements angular.IOnInit {
  static $inject = ['ReportViewDataService', 'RxStoreService', 'ReportViewerFacade'];

  reportOwnerId: string;
  iframeSrc$: Observable<string>;
  showReportView$: Observable<boolean>;

  constructor(
    private reportViewDataService: ReportViewDataService,
    private rxStore: AppStore,
    private reportViewerFacade: ReportViewerFacade
  ) {}

  $onInit(): void {
    this.iframeSrc$ = this.reportViewerFacade.iframeSrc$;
    this.showReportView$ = combineLatest([
      this.reportViewerFacade.isReportBuilderEmpty$,
      this.rxStore.select(routerSelector),
    ]).pipe(
      map(([isReportBuilderEmpty, routerState]) => {
        const isReportViewDetailsTab =
          routerState.name === 'reportShow.noRuns.dashboard' || routerState.name === 'reportShow.runs.dashboard';
        return isReportViewDetailsTab ? isReportBuilderEmpty : isReportViewDetailsTab;
      })
    );
  }

  linkToPage(query, type) {
    // @TODO: (@anthonysimone) [GF] - This still depends on the legacy flow because of the service dependency,
    // follow up to move these helpers to a more generic place to support GF flow.
    const state = this.reportViewDataService.getLinkedState(query, type);
    this.reportViewDataService.navigate(state);
  }
}

export const ID = 'reportDashboard';

export const reportDashboard: angular.IComponentOptions = {
  bindings: { iframeLoaded: '&' },
  template: `
  <report-viewer
    src="ctrl.iframeSrc$ | async:this"
    class="overflow-iframe"
    style="height:100%;"
    link-to-page="ctrl.linkToPage(query,type)"
    ng-show="!(ctrl.showReportView$ | async:this)">
  </report-viewer>
  <div ng-if="(ctrl.showReportView$ | async:this) && ctrl.reportViewDataService.executing !== true">
    <empty-report-state></empty-report-state>
  </div>
  `,
  controller: ReportDashboard,
  controllerAs: 'ctrl',
};
